import classNames from 'classnames'
import React, { FC } from 'react'
import ArrowIcon from '../assets/icons/arrow.svg'
import { Link, LinkProps } from './Link'

interface LinkListItem extends Omit<LinkProps, 'children'> {
  text: string
}

export interface LinkListProps {
  links: LinkListItem[]
}

export const LinkList: FC<LinkListProps> = ({ links }) => (
  <ul>
    {!!links?.length &&
      links.map((link, index) => (
        <li className="w-full" key={index}>
          <Link
            {...link}
            className={classNames(
              'flex justify-between items-center w-full py-7 font-t text-t-300 text-secondary border-b border-neutral-lighter-alt transition-hover group',
              'hover:text-primary focus:text-primary focus:border-primary focus:outline-none'
            )}
          >
            {link.text}

            <ArrowIcon className="w-9 h-9 text-current fill-current transform -rotate-90 transition-hover" />
          </Link>
        </li>
      ))}
  </ul>
)
